 <template>
    <div class="constestant_list_container container">
      <div class="row">

        <div class="col-12"
        v-for="contestant in contestants"
        :key="contestant.finalistid"
        >

          <div class="contestant_name_no_img" 
          v-text="contestant.name"
          :class="{ contestant_selected: selected_contestant.finalistid == contestant.finalistid}"
          ></div>

          <div class="contest_name_cover"
          @click="update_selected_contestant(contestant)"
          ></div>

        </div>

      </div>
    </div>
</template>

<script>
export default {
  name: 'ContestantListWithOutImages',
  props: [
    'contestants'
  ],
  data () {
    return {
      selected_contestant: {}
    }
  },
  methods: {
    update_selected_contestant: function(contestant) {
      this.selected_contestant = contestant;
      
      // LET PARENT KNOW THAT A SELECTION WAS MADE
      this.$emit('contestant_selected', contestant);
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.constestant_list_container {

  .row {
    background: #FFF;
    color: inherit;
  }

  .contestant_name_no_img {
    background: $dcom-orange;
    color: #FFF;
    padding: 0.5rem 0.5rem;
    /*padding-left: 1em;*/
    margin-bottom: 0.5em;
    cursor: pointer;
    font-size: 1.4em;
  }

  .contestant_name_no_img.contestant_selected {
    background: #FFF;
    color: $dcom-orange;
    border: solid 1px $dcom-orange;
    /*font-weight: bold;*/
  }

  .contest_name_cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
  }

}


</style>


// WEBPACK FOOTER //
// src/features/vote/ContestantListWithOutImages.vue